var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { cssSpacing, cssColorValue } from '@spotify-internal/encore-web/core';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { NavBarHeightSmScreen, SideFlyoutTopBarZIndex, } from '../../../constants';
import { ONE_COLUMN_MAX_WIDTH } from '../../../FlyoutMenu/MenuLayouts/Grid';
import { SECONDS_OUT } from '../FlyoutMenu/config';
import { MenuHeader } from './MenuHeader';
import { MenuTrigger } from './MenuTrigger';
var HeaderWrapper = styled.header.withConfig({
    shouldForwardProp: function (prop) { return !['isScrollingUp', 'isSideNavOpen'].includes(prop); }
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  transform: ", ";\n\n  color: ", ";\n  background-color: ", ";\n  height: ", "px;\n  align-items: center;\n  box-sizing: border-box;\n  transition: transform 400ms ease,\n    background\n      ", ";\n  display: flex;\n  flex: 1;\n  justify-content: space-between;\n  position: fixed;\n  padding-inline: ", ";\n  top: 0;\n  width: 100%;\n  z-index: ", ";\n  overflow: hidden;\n  @media (max-width: ", ") {\n    padding-inline: ", ";\n  }\n"], ["\n  transform: ", ";\n\n  color: ", ";\n  background-color: ", ";\n  height: ", "px;\n  align-items: center;\n  box-sizing: border-box;\n  transition: transform 400ms ease,\n    background\n      ", ";\n  display: flex;\n  flex: 1;\n  justify-content: space-between;\n  position: fixed;\n  padding-inline: ", ";\n  top: 0;\n  width: 100%;\n  z-index: ", ";\n  overflow: hidden;\n  @media (max-width: ", ") {\n    padding-inline: ", ";\n  }\n"])), function (props) {
    return !props.theme.isScrolling || props.isScrollingUp || props.isSideNavOpen
        ? 'none'
        : "translateY(-".concat(NavBarHeightSmScreen, "px)");
}, cssColorValue('textBase'), function (props) {
    if (!props.theme.isScrolling) {
        return 'transparent';
    }
    return 'black';
}, NavBarHeightSmScreen, function (props) {
    return props.theme.isScrolling
        ? '1000ms cubic-bezier(0.9, 0, 1, 1)'
        : '400ms ease 100ms';
}, cssSpacing('looser-3'), SideFlyoutTopBarZIndex, ONE_COLUMN_MAX_WIDTH, cssSpacing('base'));
export var TopBar = function (_a) {
    var isMenuOpen = _a.isMenuOpen, openMenu = _a.openMenu, closeMenu = _a.closeMenu, isScrollingUp = _a.isScrollingUp, onBack = _a.onBack, label = _a.label;
    var _b = useState(false), isMenuClosing = _b[0], setIsMenuClosing = _b[1];
    useEffect(function () {
        setTimeout(function () { return setIsMenuClosing(false); }, (SECONDS_OUT + 0.1) * 1000);
    }, [isMenuClosing]);
    return (React.createElement(HeaderWrapper, { isScrollingUp: isScrollingUp, isSideNavOpen: isMenuOpen, className: "encore-creator-light-theme encore-inverted-dark-set" },
        React.createElement(MenuHeader, { isMenuOpen: isMenuOpen, onBack: onBack, label: label }),
        React.createElement(MenuTrigger, { isMenuOpen: isMenuOpen, onOpen: function () { return !isMenuClosing && openMenu(); }, onClose: function () {
                setIsMenuClosing(true);
                closeMenu();
            } })));
};
var templateObject_1;
